/* RapidCare - home page behaviors
   Ported from home-app.js; finder now data-driven from the Shopify catalog
   injected in #rcFinderCatalog. Handles: kit finder (3 variants), best-seller
   tabs, deal countdown. Accordions are handled globally by RCAccordion(). */
(function () {
  'use strict';

  /* ── Kit finder ─────────────────────────────────────────── */
  var card = document.getElementById('finderCard');
  var catalog = [];
  try { catalog = JSON.parse(document.getElementById('rcFinderCatalog').textContent); } catch (e) {}

  var comUrl = card ? card.getAttribute('data-com-url') : '/collections/commercial-kits';
  var perUrl = card ? card.getAttribute('data-per-url') : '/collections/personal-kits';
  var quoteUrl = card ? card.getAttribute('data-quote-url') : '/pages/quote';

  var WORK = [
    { v: 'construction', label: 'Construction & Trades', kind: 'commercial' },
    { v: 'warehouse', label: 'Warehouse & Industrial', kind: 'commercial' },
    { v: 'office', label: 'Office & Retail', kind: 'commercial' },
    { v: 'home', label: 'Home & Family', kind: 'personal', cat: 'home' },
    { v: 'vehicle', label: 'Vehicle / Auto', kind: 'personal', cat: 'vehicle' },
    { v: 'outdoor', label: 'Outdoor & Travel', kind: 'personal', cat: 'outdoor' }
  ];
  var SIZES = [
    { v: '1-10', label: '1–10 people', min: 10 },
    { v: '11-25', label: '11–25 people', min: 25 },
    { v: '26-50', label: '26–50 people', min: 50 },
    { v: '51-100', label: '51–100 people', min: 100 },
    { v: '100+', label: '100+ people / multi-site', min: 999 }
  ];

  function commercialFor(minPersons) {
    var commercial = catalog.filter(function (p) { return p.type === 'commercial' && p.persons > 0; });
    if (!commercial.length) return null;
    commercial.sort(function (a, b) { return a.persons - b.persons; });
    var match = commercial.filter(function (p) { return p.persons >= minPersons; })[0];
    return match || commercial[commercial.length - 1];
  }
  function personalFor(cat) {
    var byCat = catalog.filter(function (p) { return p.type === 'personal' && p.cat === cat; })[0];
    return byCat || catalog.filter(function (p) { return p.type === 'personal'; })[0];
  }
  function recArt(p) {
    return p && p.image ? '<img src="' + p.image + '" alt="">' : placeholderSVG();
  }
  function placeholderSVG() {
    return '<svg viewBox="0 0 200 150" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="#f7f6f6"/><rect x="28" y="26" width="144" height="112" rx="8" fill="white" stroke="#dfdcdc" stroke-width="1.5"/><rect x="28" y="26" width="144" height="34" rx="8" fill="#D81220"/><rect x="60" y="95" width="80" height="22" rx="4" fill="#D81220"/><rect x="89" y="77" width="22" height="58" rx="4" fill="#D81220"/></svg>';
  }

  function updateRec() {
    var work = WORK.filter(function (w) { return w.v === document.getElementById('fWork').value; })[0];
    var sizeWrap = document.getElementById('fSizeWrap');
    var p;
    if (work.kind === 'personal') {
      if (sizeWrap) sizeWrap.style.display = 'none';
      p = personalFor(work.cat);
    } else {
      if (sizeWrap) sizeWrap.style.display = '';
      var size = SIZES.filter(function (s) { return s.v === document.getElementById('fSize').value; })[0];
      p = commercialFor(size.min);
    }
    if (!p) return;
    document.getElementById('fRec').innerHTML =
      '<div class="finder-rec-art">' + recArt(p) + '</div>' +
      '<div><div class="finder-rec-label">Our recommendation</div>' +
      '<div class="finder-rec-name">' + p.title + '</div>' +
      '<div class="finder-rec-price">from ' + p.price + (p.items ? ' · ' + p.items + ' items' : '') + '</div></div>';
    document.getElementById('fView').href = p.url;
  }

  function renderFinder(style) {
    if (!card) return;

    if (style === 'simple') {
      card.innerHTML =
        '<h3 class="finder-title">Ready when <em>it happens</em></h3>' +
        '<p class="finder-sub">Every kit exceeds 2021 OSHA/ANSI standards and ships fast from California.</p>' +
        '<div class="finder-cta" style="margin-top:0;">' +
          '<a href="' + comUrl + '" class="rc-btn rc-btn-primary rc-btn-lg">Shop Commercial Kits</a>' +
          '<a href="' + perUrl + '" class="rc-btn rc-btn-secondary">Shop Personal Kits</a>' +
          '<div class="finder-alt"><a href="' + quoteUrl + '">Outfitting a whole company? Get a bulk quote →</a></div>' +
        '</div>';
      return;
    }

    if (style === 'cats') {
      card.innerHTML =
        '<h3 class="finder-title">Shop by <em>category</em></h3>' +
        '<p class="finder-sub">Pick your world - we\'ll show the kits that fit.</p>' +
        '<div class="finder-seg" id="fSeg"><button class="active" data-seg="commercial">Commercial</button><button data-seg="personal">Personal</button></div>' +
        '<div class="finder-cats" id="fCats"></div>' +
        '<div class="finder-alt" style="margin-top:14px;"><a href="' + quoteUrl + '">Need bulk pricing? Get a quote →</a></div>';
      var CATS = {
        commercial: [
          { href: comUrl + '?filter.p.tag=10-person', b: '10–25 Person', s: 'Small crews & offices' },
          { href: comUrl + '?filter.p.tag=50-person', b: '50–100 Person', s: 'Sites & warehouses' },
          { href: comUrl + '?filter.p.tag=cabinet', b: 'Trauma Stations', s: 'Wall cabinets' },
          { href: comUrl + '?filter.p.tag=refill', b: 'Refill Kits', s: 'Restock & stay compliant' }
        ],
        personal: [
          { href: perUrl + '?filter.p.tag=home', b: 'Home & Family', s: '150-piece kits' },
          { href: perUrl + '?filter.p.tag=vehicle', b: 'Vehicle / Auto', s: 'Glovebox-sized' },
          { href: perUrl + '?filter.p.tag=outdoor', b: 'Outdoor', s: 'Trail & camp' },
          { href: perUrl + '?filter.p.tag=travel', b: 'Travel', s: 'TSA-friendly' }
        ]
      };
      var renderCats = function (seg) {
        document.getElementById('fCats').innerHTML = CATS[seg].map(function (c) {
          return '<a class="finder-cat" href="' + c.href + '"><b>' + c.b + '</b><span>' + c.s + '</span></a>';
        }).join('');
      };
      document.getElementById('fSeg').addEventListener('click', function (e) {
        var btn = e.target.closest('button'); if (!btn) return;
        document.querySelectorAll('#fSeg button').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        renderCats(btn.dataset.seg);
      });
      renderCats('commercial');
      return;
    }

    /* guided (default) */
    card.innerHTML =
      '<h3 class="finder-title">Find your <em>kit</em></h3>' +
      '<p class="finder-sub">Two answers. We\'ll match the compliant kit.</p>' +
      '<div class="finder-fields">' +
        '<div class="rc-form-group"><label class="rc-form-label" for="fWork">Where will it live?</label>' +
        '<select class="rc-form-select" id="fWork">' + WORK.map(function (w) { return '<option value="' + w.v + '">' + w.label + '</option>'; }).join('') + '</select></div>' +
        '<div class="rc-form-group" id="fSizeWrap"><label class="rc-form-label" for="fSize">How many people on site?</label>' +
        '<select class="rc-form-select" id="fSize">' + SIZES.map(function (s) { return '<option value="' + s.v + '"' + (s.v === '26-50' ? ' selected' : '') + '>' + s.label + '</option>'; }).join('') + '</select></div>' +
      '</div>' +
      '<div class="finder-rec" id="fRec"></div>' +
      '<div class="finder-cta"><a href="#" class="rc-btn rc-btn-primary" id="fView" style="justify-content:center;">View This Kit →</a>' +
      '<div class="finder-alt"><a href="' + quoteUrl + '">Ordering for multiple sites? Get a bulk quote →</a></div></div>';
    document.getElementById('fWork').addEventListener('change', updateRec);
    document.getElementById('fSize').addEventListener('change', updateRec);
    updateRec();
  }

  if (card) renderFinder(card.getAttribute('data-finder-style') || 'guided');

  /* ── Best-seller tabs ───────────────────────────────────── */
  var tabs = document.getElementById('prodTabs');
  if (tabs) {
    tabs.addEventListener('click', function (e) {
      var btn = e.target.closest('button'); if (!btn) return;
      var filter = btn.getAttribute('data-filter');
      tabs.querySelectorAll('button').forEach(function (b) { b.classList.toggle('active', b === btn); });
      document.querySelectorAll('[data-prod-group]').forEach(function (g) {
        g.style.display = g.getAttribute('data-prod-group') === filter ? '' : 'none';
      });
    });
  }

  /* ── Deal countdown - ends Sunday midnight ──────────────── */
  function dealTick() {
    var el = document.getElementById('dealCount');
    if (!el) return;
    var now = new Date();
    var end = new Date(now);
    end.setDate(now.getDate() + ((7 - now.getDay()) % 7 || 7));
    end.setHours(0, 0, 0, 0);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var d = Math.floor(s / 86400); s -= d * 86400;
    var hh = Math.floor(s / 3600); s -= hh * 3600;
    var mm = Math.floor(s / 60); s -= mm * 60;
    el.innerHTML = [['Days', d], ['Hrs', hh], ['Min', mm], ['Sec', s]].map(function (x) {
      return '<div><b>' + String(x[1]).padStart(2, '0') + '</b><span>' + x[0] + '</span></div>';
    }).join('');
  }
  if (document.getElementById('dealCount')) { dealTick(); setInterval(dealTick, 1000); }
})();
